import React, { useContext } from 'react';
import ReactProgressBar from '@ramonak/react-progress-bar';
import { ThemeContext } from 'styled-components';

function ProgressBar({ uploadProgress, color = 'primary' }) {
  const themeContext = useContext(ThemeContext);

  const bgColor =
    color === 'error'
      ? themeContext?.button.danger.out
      : themeContext?.button.primary.out;

  return <ReactProgressBar completed={uploadProgress} bgColor={bgColor} />;
}

export default ProgressBar;
